export const MIN_TRIALS = 25; // FIXME this seems very low, but is what we use in v1
